import { routes } from '@/constants.ts';

// Detect Cyrillic by Unicode *script*, not a character list. This also catches
// homoglyphs — Cyrillic а/е/о/р/с render identically to Latin a/e/o/p/c — which
// a glyph list would miss but which still break Latin-only downstream systems.
// Latin diacritics (Spanish names like José/Peña) are intentionally allowed.
const CYRILLIC = /\p{Script=Cyrillic}/u;

export const containsCyrillic = (value: string): boolean => CYRILLIC.test(value);

// After a successful application the candidate goes to the Welcome screen, not
// straight into the interview: Welcome is where they choose the language the
// interview will be conducted in. `routes.root` is what renders Welcome — there
// is no `/welcome` route, and the router's catch-all would strip the query
// string (and with it the invitation key) if we invented one.
export const interviewHandoffPath = (invitationKey: string) =>
  `${routes.root}?invitation_key=${invitationKey}`;
